import { cva } from "class-variance-authority";

export const navLinkVariants = cva(
  "w-full",
  {
    variants: {
      state: {
        active: "[&_svg]:text-orange-500 bg-orange-100 rounded-xl",
        disabled: "pointer-events-none",
      },
    },
  },
);
